/* eslint import/prefer-default-export: 0 */

import * as t from './action_types';

/**
 * @param {Object} params
 */
export const updateDimensions = params => ({
  type: t.ACTIVE_DIMENSIONS_UPDATE,
  payload: params,
});
